import store from "@src/reducers/store";

export class BlueprintRepository {
  private author: string;
  private organization: string;

  constructor() {
    this.author = store.getState().yourSlice.authContext.fullName;
    this.organization = store.getState().yourSlice.authContext.organization;
  }

  getAuthor(): string {
    return this.author || "unkown author";
  }

  getOrganization(): string {
    return this.organization || "unkown organization";
  }
}
